import consts from "./_consts";
export default {
  name: "admin",
  path: "/admin",
  items: {
    home: {
      name: "Home",
      url: "/admin/home",
      entity: ["all"],
      icon: consts.iconNames.home
    },
    program: {
      name: "Programs",
      url: "/admin/programs",
      entity: ["program"],
      permissionName: "prog__program__index",
      icon: consts.iconNames.program,
      children: {
        program_template: {
          name: "Program Templates",
          url: "/admin/programs/templates",
          hidden: true
        },
        program_create: {
          name: "admin_program_create",
          url: "/admin/programs/create/:type",
          hidden: true
        },
        program_info: {
          name: "admin_program_info",
          url: "/admin/programs/:id/info",
          hidden: true
        },
        program_date: {
          name: "admin_program_date",
          url: "/admin/programs/:id/date",
          hidden: true
        },
        program_structure_points: {
          name: "admin_program_structure_points",
          url: "/admin/programs/:id/structure-points",
          hidden: true
        },
        program_milestone_settings: {
          name: "admin_program_milestone_settings",
          url: "/admin/programs/:id/milestone-settings",
          hidden: true
        },
        program_milestone_rewards_completion: {
          name: "admin_program_milestone_rewards_completion",
          url: "/admin/programs/:id/milestone-completion-rewards",
          hidden: true
        },
        program_outcomes: {
          name: "admin_program_outcomes",
          url: "/admin/programs/:id/outcomes",
          hidden: true
        },
        program_cohorts: {
          name: "admin_program_cohorts",
          url: "/admin/programs/:id/cohorts",
          hidden: true
        },
        program_appeals_form: {
          name: "admin_program_appeals_form",
          url: "/admin/programs/:id/appeals-form",
          hidden: true
        },
        program_tobacco: {
          name: "admin_program_tobacco",
          url: "/admin/programs/:id/tobacco",
          hidden: true
        },
        program_points: {
          name: "admin_program_points",
          url: "/admin/programs/:id/points",
          hidden: true
        },
        program_level_rewards: {
          name: "admin_program_level_rewards",
          url: "/admin/programs/:id/level-rewards",
          hidden: true
        },
        program_summary: {
          name: "admin_program_summary",
          url: "/admin/programs/:id/summary",
          hidden: true
        },
        program_activity: {
          name: "admin_program_activity",
          url: "/admin/programs/:id/activities",
          hidden: true
        },
        program_level_paths: {
          name: "admin_program_level_paths",
          url: "/admin/programs/:id/level-paths",
          hidden: true
        },
        program_level_practices: {
          name: "admin_program_level_practices",
          url: "/admin/programs/:id/level-practices",
          hidden: true
        },
        program_level_activities: {
          name: "admin_program_level_activity",
          url: "/admin/programs/:id/level-activities",
          hidden: true
        },
        program_ras_activities: {
          name: "admin_program_ras_activities",
          url: "/admin/programs/:id/ras-activities",
          hidden: true
        },
        program_ras_paths: {
          name: "admin_program_ras_paths",
          url: "/admin/programs/:id/ras-paths",
          hidden: true
        },
        program_activity_view: {
          name: "admin_program_activity_view",
          url: "/admin/programs/:id/activities/:aid/view",
          hidden: true
        },
        program_level_activity_view: {
          name: "admin_program_level_activity_view",
          url: "/admin/programs/:id/level-activities/:aid/view",
          hidden: true
        },
        program_reward_error: {
          name: "Reward Logs",
          url: "/admin/program-management/program-reward",
          entity: ["program"],
          hidden: true
        },
        reward_access_token: {
          name: "Reward Access Token",
          url: "/admin/program-management/reward-access-token",
          entity: ["program"],
          hidden: true
        },
        add_reward_access_token: {
          name: "add-reward-access-token",
          url: "/admin/program-management/reward-access-token/add",
          hidden: true
        },
        edit_reward_access_token: {
          name: "edit-reward-access-token",
          url:
            "/admin/program-management/reward-access-token/:programId/client/:clientId/edit",
          hidden: true
        },
        program_reward_history: {
          name: "Reward History",
          url: "/admin/program-management/:id/reward-history",
          hidden: true
        },
        program_collections: {
          name: "admin_program_collections",
          url: "/admin/programs/:id/collections",
          hidden: true
        }
      }
    },
    client: {
      name: "Clients",
      url: "/admin/clients",
      entity: ["employer"],
      permissionName: "em__employer__index",
      icon: consts.iconNames.clients,
      children: {
        add_new_client: {
          url: "/admin/clients/add",
          name: "add-new-client",
          hidden: true
        },
        edit_client: {
          url: "/admin/clients/:id/edit",
          name: "edit-client",
          hidden: true
        },
        client_rewards_setting: {
          url: "/admin/clients/:id/client_rewards_setting",
          name: "client_rewards_setting",
          hidden: true
        }
      }
    },
    user: {
      name: "User",
      url: "/admin/users",
      entity: ["user", "role"],
      permissionName: "cc__user__index",
      expandIcon: true,
      collapse_id: "role-collapse-id",
      icon: consts.iconNames.user,
      children: {
        add_user: {
          name: "admin-add-user",
          url: "/admin/users/add-new",
          hidden: true
        },
        edit_user: {
          name: "admin-edit-user",
          url: "/admin/users/:id/edit",
          hidden: true
        },
        role: {
          name: "Role",
          url: "/admin/users/roles",
          permissionName: "cc__role__index",
          entity: ["role"]
        },
        add_role: {
          name: "admin-add-role",
          url: "/admin/users/roles/add-role",
          hidden: true
        },
        edit_role: {
          name: "admin-edit-role",
          url: "/admin/users/roles/:id/edit",
          hidden: true
        },
        activity_log: {
          name: "Activities Logs",
          url: "/admin/users/activities",
          permissionName: "cc__activity_logs__index",
          entity: ["user"]
        },
        client_admin: {
          name: "Client Admin",
          url: "/admin/client-admins",
          permissionName: "cc__user_client_admin__index",
          entity: ["user"]
        },
        client_admin_add: {
          name: "Client Admin Add",
          url: "/admin/client-admins/add",
          hidden: true
        },
        client_admin_edit: {
          name: "Client Admin Edit",
          url: "/admin/client-admins/edit/:id",
          hidden: true
        },
        client_admin_need_reviews: {
          name: "Need Reviews",
          url: "/admin/client-admins/need-reviews",
          hidden: true
        },
        client_admin_change_log: {
          name: "Admin Change Log",
          url: "/admin/client-admins/change-log",
          hidden: true
        }
      }
    },
    employee: {
      name: "Eligible Population",
      url: "/admin/eligible-population",
      entity: ["employee"],
      permissionName: "em__employee__index",
      icon: consts.iconNames.eligiblePopulation,
      children: {
        add_new_employee: {
          name: "admin-add-new-employee",
          url: "/admin/eligible-population/add-new"
        },
        edit_employee: {
          name: "admin-edit-employee",
          url: "/admin/eligible-population/:id/edit"
        },
        reward_history: {
          name: "admin-employee-reward-history",
          url: "/admin/eligible-population/:id/reward-history"
        },
        history: {
          name: "admin-employee-history",
          url: "/admin/eligible-population/:id/history"
        }
      }
    },
    data_feeds: {
      name: "Data Feeds",
      url: "/admin/data-feeds",
      expandIcon: true,
      collapse_id: "data-feeds-collapse-id",
      entity: ["employer", "certificate", "sftp"],
      permissionName: "em__data_feed__index",
      icon: consts.iconNames.dataFeeds,
      children: {
        add_client_sftp: {
          name: "Add Data Transaction",
          url: "/admin/data-feeds/add",
          hidden: true
        },
        edit_client_sftp: {
          name: "Edit Data Transaction",
          url: "/admin/data-feeds/:id/edit",
          hidden: true
        },
        data_transaction: {
          name: "Data Transaction",
          url: "/admin/data-feeds/data-transaction",
          permissionName: "rp__data_transaction__index",
          entity: ["employer"],
          children: {
            transaction_detail: {
              name: 'Transaction Detail',
              url: '/admin/data-feeds/data-transaction/:id',
              hidden: true
            }
          }
        },
        pgp_certificate: {
          name: "PGP Certificates",
          url: "/admin/data-feeds/pgp-certificates",
          permissionName: "em__certificate__index",
          entity: ["certificate"],
          children: {
            add_pgp_certificate: {
              name: "Add Pgp Certificate",
              url: "/admin/data-feeds/pgp-certificates/add-new",
              hidden: true
            },
            edit_pgp_certificate: {
              name: "Edit Pgp Certificate",
              url: "/admin/data-feeds/pgp-certificates/:id/edit",
              hidden: true
            }
          }
        },
        file_source: {
          name: "File Source",
          url: "/admin/data-feeds/file_source",
          permissionName: "em__sftp__index",
          expandIcon: false,
          entity: ["sftp"],
          children: {
            add_file_source: {
              name: "Add File Source",
              url: "/admin/data-feeds/file_source/add",
              hidden: true
            },
            edit_file_source: {
              name: "Edit File Source",
              url: "/admin/data-feeds/file_source/:id/edit",
              hidden: true
            }
          }
        },
        columnMapping: {
          name: "Column Mapping",
          url: "/admin/data-feeds/column-mapping",
          permissionName: "em__column_mapping__index",
          expandIcon: false,
          entity: ["column_mapping"],
          children: {
            add: {
              name: "add-column-mapping",
              url: "/admin/data-feeds/column-mapping/add",
              hidden: true
            },
            edit: {
              name: "edit-column-mapping",
              url: "/admin/data-feeds/column-mapping/:id/edit",
              hidden: true
            }
          }
        }
      }
    },
    emailTemplate: {
      name: "Email Template",
      url: "/admin/email-template",
      entity: ["email_template"],
      permissionName: "email__email_template__index",
      icon: consts.iconNames.emailTemplate,
      children: {
        add_email_template: {
          name: "Add Email Template",
          url: "/admin/email-template/add",
          hidden: true
        },
        edit_email_template: {
          name: "Edit Email Template",
          url: "/admin/email-template/:id/edit",
          hidden: true
        }
      }
    },
    logs: {
      name: "Logs",
      url: "/admin/logs",
      entity: ["all"],
      permissionName: "",
      icon: consts.iconNames.logs
    },
    security: {
      name: "Security",
      url: "/admin/security",
      entity: ["system"],
      permissionName: "cc__system__policy_manage",
      icon: consts.iconNames.security
    },
    userManagement: {
      name: "Admin User Management",
      path: "/admin/user-management",
      entity: ["user"],
      permissionName: "",
      hidden: true,
      children: {
        profile: {
          name: "Admin Profile",
          path: "/admin/user-management/profile"
        },
        changePassword: {
          name: "Admin Change Password",
          path: "/admin/user-management/change-password"
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/_admin-nav.js